module.exports = __webpack_public_path__ + "static/media/numeros 1 copia.bd0f06e4.png";